import { getFirebaseToken } from 'auth/utils';
import axios from 'axios';

export const sendEmailVerificationSellerHub = async ({ token: fbToken, name = '', phone = '' }) => {
  try {
    const token = fbToken || (await getFirebaseToken());
    const result = await axios({
      method: 'GET',
      url: `${process.env.SELLER_HUB_SELLER_GRAPHQL_API}/account/sendEmailVerification?name=${encodeURIComponent(name)}&phone=${phone}`,
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return result;
  } catch (e) {
    console.error(e);
    return e;
  }
};

// Login security check (OTP, password change). These return the response
// body for non-2xx answers too (cooldown, wrong code) so the page can show
// the reason.
const accountRequest = async (path, data) => {
  try {
    const token = await getFirebaseToken();
    const result = await axios({
      method: 'POST',
      url: `${process.env.SELLER_HUB_SELLER_GRAPHQL_API}/account/${path}`,
      headers: {
        authorization: `Bearer ${token}`,
      },
      data,
    });
    return result.data;
  } catch (e) {
    console.error(e);
    return e?.response?.data || { success: false };
  }
};

export const sendLoginOtp = () => accountRequest('otp/send');

export const verifyLoginOtp = (code) => accountRequest('otp/verify', { code });

export const changePassword = (currentPassword, newPassword) =>
  accountRequest('password/change', { currentPassword, newPassword });
